module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/remittance-entry/remittance-entry.component.css
// module id = ./src/app/components/remittance-entry/remittance-entry.component.css
// module chunks = main